export default __webpack_public_path__ + "static/media/GameOfLife.e57883c4.png";